export default "__VITE_ASSET__DF7wmx87__"